import React from 'react';
import createBugSnagger from './initialisers/BugSnag';
import AppRoutes from './components/AppRoutes';
import AppError from './components/AppError';
import createStore from './initialisers/CreateStore';
import { StoreProvider } from './State';
import { makeServer } from './mirage';
import { QueryProvider } from './fetch/query';

const App = () => {
  const environment = process.env.REACT_APP_ENV;
  if (environment === 'local') {
    makeServer();
  }

  const ErrorBoundary = createBugSnagger();
  return (
    <ErrorBoundary FallbackComponent={AppError}>
      <StoreProvider store={createStore()}>
        <QueryProvider>
          <AppRoutes />
        </QueryProvider>
      </StoreProvider>
    </ErrorBoundary>
  );
};

export default App;
